import { render, staticRenderFns } from "./LoyaltyRewardForm.vue?vue&type=template&id=00470e51&"
import script from "./LoyaltyRewardForm.vue?vue&type=script&lang=js&"
export * from "./LoyaltyRewardForm.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyRewardForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports